<template>
    <div class="HdHost">
        <div class="host_bg">
            <div class="host_tab">
                <div class="tab_item">
                    <span @click="menuClick(1)" :class="menuIndex === 1 ? 'active' : ''">全部活动</span>
                    <span @click="menuClick(2)" :class="menuIndex === 2 ? 'active' : ''">进行中活动</span>
                </div>
            </div>
        </div>
        <!--下面部分-->
        <div class="host_main">
            <div class="mainLeft">
                <div class="leftList" v-if="eventList.length>0">
                    <div class="hostItem" v-for="(item,index) in eventList" :key="index">
                        <IndexList  :dataList="item"></IndexList>
                    </div>
                </div>
                <div class="noData_wrap" v-else>
                    <img :src="noData" alt="">
                    <p>当前暂无活动 </p>
                </div>
                <div v-show="eventList.length > 0" class="page_box evaluate_page_box">
                    <el-pagination background layout="prev, pager, next" :page-size="18" :total="hostPageTotal"  @current-change="hostPage"></el-pagination>
                </div>
            </div>
            <div class="mainRight">
                <div class="mainItem hostInfo_box">
                    <img :src="hostInfo.hostpic" alt="">
                    <p class="name">{{hostInfo.hostname}}</p>
                    <div class="flex_item">
                        <div class="activeNum">
                            <p>活动数</p>
                            <p class="blue">{{hostInfo.eventcount}}</p>
                        </div>
                        <div>
                            <p>粉丝数</p>
                            <p class="blue">{{hostInfo.favoritecount}}</p>
                        </div>
                    </div>
                    <el-button type="danger" plain @click="followClick(hostInfo.isfavorite)">{{hostInfo.isfavorite==0?'+ 关注':'取消关注'}}</el-button>
                </div>
                <template v-if="hostInfo.hostdesp">
                    <div class="rightTitle">主办方简介</div>
                    <div class="mainItem"><span class="desp">{{hostInfo.hostdesp}}</span></div>
                </template>
                <template v-if="hostInfo.mpqrcode">
                    <div class="rightTitle">微信公众号</div>
                    <div class="mainItem serve_box">
                        <img :src="hostInfo.mpqrcode" alt="">
                        <div>
                            <p>{{hostInfo.mpname}}</p>
                            <p class="subDesp">关注公众号了解更多</p>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import {getEventByHost,getHostDetail,operateHostFollowInfo} from 'api/hdApi'
    import {mapGetters,mapActions} from 'vuex'
    import IndexList from '@/views/hdPc/components/indexList'
    import $ from 'jquery'
    export default {
        name: "HdHost",
        data(){
            return{
                menuIndex: 1, //导航
                eventList:[], //活动列表
                hostInfo:{},
                hostPageTotal: 0, // 主办方全部页码
                noData:require('@/common/images/hd/noData.png'),
            }
        },
        mounted () {
          this._getActiveList(1);
          this._getHost()
        },
        methods: {
            // 导航点击
            menuClick(val) {
                this.menuIndex = val;
                this._getActiveList(1);
            },
            //获取主办方活动列表
            _getActiveList(val){
                this.setLoading(true);
                let param={
                    hostid:this.$route.query.hostid,
                    page:val,
                    pageSize:18,
                    seetype:this.menuIndex===1?1:2
                };
                getEventByHost({
                    data: Object.assign({}, param),
                    success: data => {
                        this.setLoading(false);
                        this.eventList=data.data.content;
                        this.hostPageTotal = data.data.pageinfo.rowCount
                    },
                    error: data => {
                        this.$message.error(data.msg)
                    }
                })
            },
            // 主办方活动分页
            hostPage(){
                let clickPage = $(".evaluate_page_box .el-pagination .active").html();
                this._getActiveList(clickPage)
            },
            //获取主办方详情
            _getHost(){
                this.setLoading(true);
                let param={
                    hostid:this.$route.query.hostid,
                };
                getHostDetail({
                    data: Object.assign({}, param),
                    success: data => {
                        this.setLoading(false);
                        this.hostInfo=data.data
                    },
                    error: data => {
                        this.$message.error(data.msg)
                    }
                })
            },
            //关注/取消关注
            followClick(val){
                if(this.user.isLogin===true){
                    this.setLoading(true);
                    let params = {
                        hostid: this.$route.query.hostid,
                        optype: val === 1 ? 2 : 1,
                    };
                    operateHostFollowInfo({
                        data: Object.assign({}, params),
                        success: data => {
                            this.setLoading(false)
                            if (data.code === '000') {
                                if (val === 1) {
                                    this.hostInfo.isfavorite = 0;
                                    this.$message.success('已取消关注')
                                } else {
                                    this.hostInfo.isfavorite = 1;
                                    this.$message.success('关注成功')
                                }
                            }
                        },
                        error: data => {
                            this.setLoading(false)
                            this.$message.error(data.msg)
                        }
                    })
                }else{
                    this.setLoginPop(true)
                }
            },
            ...mapActions([
                'setLoading',
                'setLoginPop',
                'setUser'
            ])
        },
        computed: {
            ...mapGetters(['loginPop', 'user','domainInfo'])
        },
        components:{
            IndexList
        }
    }
</script>

<style scoped lang="scss">
    .HdHost{
        .host_bg{
            width: 100%;
            height: 240px;
            background: url("../../../common/images/hd/hostBg.png") no-repeat center;
            background-size: cover;
            position: relative;
            .host_tab{
                width: 100%;
                height:70px;
                background:rgba(0,0,0,0.4);
                position: absolute;
                bottom: 0;
                .tab_item{
                    width: 1200px;
                    margin: 0 auto;
                    span{
                        width:140px;
                        height:70px;
                        line-height: 70px;
                        font-size: 16px;
                        color: #fff;
                        display: inline-block;
                        text-align: center;
                        cursor: pointer;
                    }
                    .active{
                        background:rgba(255,255,255,0.5);
                    }
                }
            }
        }
        .host_main{
            width: 1200px;
            margin: 30px auto;
            display: flex;
            justify-content: space-between;
            .mainLeft{
                width: 100%;
                .leftList{
                    display: flex;
                    flex-wrap: wrap;
                    /*justify-content: space-between;*/
                    .hostItem{
                        margin-bottom: 20px;
                        margin-right: 20px;
                    }
                    .hostItem:nth-child(3n){
                        margin-right: 0;
                    }
                }
                .noData_wrap{
                    text-align: center;
                    width: 100%;
                    font-size: 12px;
                    color: #999;
                    padding-top: 100px;
                    img{
                        margin: 0 auto 12px;
                    }
                }
                .evaluate_page_box{
                    margin: 0 auto;
                    .el-pagination{
                        text-align: center;
                    }
                }
            }
            .mainRight{
                width: 285px;
                min-width: 285px;
                margin-left: 20px;
                .rightTitle{
                    font-size: 16px;
                    color: #333;
                    margin-bottom: 20px;
                    font-weight: bold;
                }
                .mainItem{
                    box-shadow:0px 0px 8px 0px rgba(0,0,0,0.1);
                    padding: 20px 0;
                    margin-bottom: 20px;
                    .desp{
                        line-height: 25px;
                        padding: 0 20px;
                        display: inline-block;
                        color: #666;
                    }
                }
                .hostInfo_box{
                    position: relative;
                    margin-top: -150px;
                    background: #fff;
                    img{
                        width: 200px;
                        height: 200px;
                        margin: 0 auto;
                    }
                    .name{
                        font-size: 20px;
                        line-height:28px;
                        padding: 15px 0 15px;
                        text-align: center;
                    }
                    .flex_item{
                        display: flex;
                        justify-content: space-around;
                        color: #666;
                        text-align: center;
                        margin-bottom: 15px;
                        .activeNum{
                            border-right: 1px solid #eee;
                        }
                        .blue{
                            color: #1464C8;
                            padding-top: 8px;
                        }
                    }
                    .flex_item>div{
                        flex: 1;
                    }
                    .el-button{
                        padding: 10px 30px;
                    }
                    .el-button--danger.is-plain{
                        display: flex;
                        margin: auto;
                        color: #1464C8;
                        border-color: rgba(20,100,200,1);
                        background: none;
                    }
                    .el-button--danger.is-plain:focus, .el-button--danger.is-plain:hover {
                        background: rgba(20,100,200,1);
                        border-color: rgba(20,100,200,1);
                        color: #FFF;
                        outline: 0;
                    }
                }
                .serve_box{
                    display: flex;
                    align-items: center;
                    padding: 20px;
                    img{
                        width: 80px;
                        height: 80px;
                        margin-right: 20px;
                    }
                    .subDesp{
                        margin-top: 8px;
                        font-size: 12px;
                        color: #999;
                    }
                }
            }
        }
    }
</style>